import { render, staticRenderFns } from "./Youtubehelp.vue?vue&type=template&id=b78d5830"
import script from "./Youtubehelp.vue?vue&type=script&lang=js"
export * from "./Youtubehelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports